export const allRelations = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ALLRELATIONS':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export const allGroups = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ALLGROUPS':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export const relationReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_RELATION':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export const userrightsReducer = (state={}, action) => {
    switch (action.type) {
        case 'SET_USERRIGHTS':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export const userdataReducer = (state={}, action) => {
    switch (action.type) {
        case 'SET_USERDATA':
            state = action.payload;
            return state;
        default:
            return state;
    }
}